import axios from 'axios'

export const baseURL = '/api'

export const ajax = axios.create({
  baseURL: baseURL,
  // 斑马数据测试环境查询需要15秒左右时间，所以暂时先配置成20秒
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8',
    'X-Requested-With': 'XMLHttpRequest',
    'yame-source': 'gip'
  }
  // withCredentials: true
})

export const ajax2 = axios.create({
  baseURL: '',
  // 斑马数据测试环境查询需要15秒左右时间，所以暂时先配置成20秒
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8',
    'X-Requested-With': 'XMLHttpRequest',
    'yame-source': 'gip'
  }
  // withCredentials: true
})

export const download = function (url, param, method, callback) {
  let flag = true
  return axios({
    method: method || 'post',
    baseURL: baseURL,
    url: url,
    data: param,
    // 导出时间避免过长，修改为60s
    timeout: 60000,
    withCredentials: true,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    responseType: 'blob'
  }).then(response => {
    flag = parseResp(response)
    if (callback) {
      let msg = '下载开始'
      if (!flag) {
        msg = '下载异常，请稍后再试或重新登录后再试'
      }
      callback(flag, msg)
    }
  }).catch(e => {
    if (callback) {
      flag = false
      callback(flag, '网络异常:' + e.message + '，请重新登录后再试')
    }
  })
}

export const serviceDownload = function (url, param, method, callback) {
  let flag = true
  return axios({
    method: method || 'post',
    url: url,
    data: param,
    // 导出时间避免过长，修改为60s
    timeout: 60000,
    withCredentials: true,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    responseType: 'blob'
  }).then(response => {
    flag = parseResp(response)
    if (callback) {
      let msg = '下载开始'
      if (!flag) {
        msg = '下载异常，请稍后再试或重新登录后再试'
      }
      callback(flag, msg)
    }
  }).catch(e => {
    if (callback) {
      flag = false
      callback(flag, '网络异常:' + e.message + '，请重新登录后再试')
    }
  })
}

// 解析返回下载的response
function parseResp (response) {
  if (!response.data || response.data.type === 'text/html') {
    return false
  }
  const contentDisposition = response.headers['content-disposition']
  const filename = decodeURI(contentDisposition.match(/filename="(.+)"/i)[1])
  const url = window.URL.createObjectURL(new Blob([response.data]))
  const link = document.createElement('a')
  link.style.display = 'none'
  link.href = url
  link.setAttribute('download', filename)
  document.body.appendChild(link)
  link.click()
  return true
}



// WEBPACK FOOTER //
// ./src/libs/ajax/ops.js